/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IModifier,
  IModifierInterface,
} from "../../../../contracts/periphery/AvatarIsOwnerOfERC721.sol/IModifier";

const _abi = [
  {
    inputs: [],
    name: "avatar",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "target",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class IModifier__factory {
  static readonly abi = _abi;
  static createInterface(): IModifierInterface {
    return new Interface(_abi) as IModifierInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): IModifier {
    return new Contract(address, _abi, runner) as unknown as IModifier;
  }
}
